import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from '../http.service';
import { HelperService } from '../helper.service';
import { HttpClient } from '@angular/common/http';
import * as XLSX from 'xlsx';
import { HttpFileService } from '../http-file.service';

const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.csv';
import * as FileSaver from 'file-saver';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class ManualOrderService {
  constructor(
    private httpService: HttpService,
    public helperService: HelperService,
    public httpClient: HttpClient,
    private router: Router,
    private httpFileService: HttpFileService
  ) {}

  getAddresses(payload: any) {
    return this.httpService.post(`admin/user/user_get_address`, payload);
  }

  getInsuranceList(payload: any) {
    return this.httpService.post(`admin/user/insurance`, payload);
  }

  getCountryList(payload: any) {
    return this.httpService.post(`admin/get/countries/list`, payload);
  }
  getstateList(payload: any) {
    return this.httpService.post(`admin/get/state-list`, payload);
  }

  getUserList(payload: any) {
    return this.httpService.post(`admin/user/user_search_list`, payload);
  }
  addUserAddress(payload: any) {
    return this.httpService.post(`admin/user/user_add_address`, payload);
  }

  addUserInsurance(payload: FormData, options: any) {
    return this.httpFileService.post(`admin/user/add_insurance`, payload, options);
  }

  getDrugList(payload: any) {
    return this.httpService.post(`admin/drugs/autocomplete`, payload);
  }

  saveManualOrder(payload: any){
    return this.httpService.post(`admin/manual/orderCreate`, payload);
  }

  ValidateRxDetail(payload: any){
    return this.httpService.post(`admin/manual/getrxmedications`, payload);
  }

  CreateDrug(payload: any){
    return this.httpService.post(`admin/drugs/create`, payload);
  }

  CreateNursingHome(payload: any){
    return this.httpService.post(`admin/manual/add_nursinghome`, payload);
  }
}
